/**
 * @generated SignedSource<<8fb787954c3072c26472ffc088a840d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithMobileDescription_shoppingWith$data = {
  readonly description: string | null;
  readonly links: {
    readonly links: ReadonlyArray<{
      readonly label: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithSocial_shoppingWith">;
  readonly " $fragmentType": "ShoppingWithMobileDescription_shoppingWith";
};
export type ShoppingWithMobileDescription_shoppingWith$key = {
  readonly " $data"?: ShoppingWithMobileDescription_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithMobileDescription_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithMobileDescription_shoppingWith",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithSocial_shoppingWith"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShoppingWithLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ShoppingWithLink",
          "kind": "LinkedField",
          "name": "links",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "a27aaf02bb46680058b73f2faceeef33";

export default node;
